import useSWR from 'swr';
export interface TransactionDetail {
  id: number;
  applyBalanceLimit: boolean;
  applyBalanceMinimumLimit: boolean;
  balanceLimit: number;
  balanceMinimumLimit: number;
  dailyLimitReceived: number;
  dailyLimitSent: number;
  dailyLimitTxReceived: number;
  dailyLimitTxSent: number;
  description: string;
  doubleFactor: boolean;
  entityId: string;
  monthlyExcessLimitReceived: number;
  monthlyExcessLimitSent: number;
  monthlyLimitReceived: number;
  monthlyLimitSent: number;
  monthlyLimitTxReceived: number;
  monthlyLimitTxSent: number;
  segmentId: number;
  transactionLimitSent: number;
  transactionLimitReceived: number;
  transactionType: string;
}
/**
 * Get limit detail by id
 * @param limitId
 * @returns {TransactionDetail} limit detail
 */
export const useGetLimitsBySegment = ({ limitId }: { limitId?: string }) => {
  const props = useSWR<TransactionDetail>(limitId && `v3/partner/limits/details/${limitId}`, {
    revalidateOnFocus: false,
  });

  return props;
};
